import React from "react";

function DataDeletion({ onBack }) {
  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="landing-title-group">
          <h1 className="landing-title">
            Data <span className="highlight">Deletion</span>
          </h1>
          <h2 className="landing-subtitle">Santa Thadeu Health Services</h2>
        </div>
      </header>
      <main className="landing-main">
        <p className="policy-date">Updated: 12 June 2026</p>

        <section className="policy-card">
          <h3>How to Delete Your Data</h3>
          <p>
            If you want us to delete any personal information we have stored
            about you, please contact us using the email address below. In your
            message, include the details you want removed and the phone number
            or email you used when submitting it.
          </p>
        </section>

        <section className="policy-card">
          <h3>What Information Can Be Removed</h3>
          <p>
            We can remove personal information collected through this website,
            including contact details, inquiry messages, and any profile data
            saved to our systems on your behalf. Data shared through external
            platforms like WhatsApp may also be deleted when it is within our
            control.
          </p>
        </section>

        <section className="policy-card">
          <h3>What to Include in Your Request</h3>
          <p>
            Please provide the phone number or email address you used, a brief
            description of the data you want removed, and whether the request is
            for website data, appointment records, membership details, or chat
            messages.
          </p>
        </section>

        <section className="policy-card">
          <h3>Processing Time</h3>
          <p>
            We aim to process deletion requests as quickly as possible. Most
            requests are completed within a few business days, but some may take
            longer if we need to verify the request or comply with legal
            obligations.
          </p>
        </section>

        <section className="policy-card">
          <h3>Contact for Deletion</h3>
          <p>
            Email us at
            <br />
            <a href="mailto:admin@santathadeu.co.zw">admin@santathadeu.co.zw</a>
            <br />
            Please include "Data Deletion Request" in the subject line.
          </p>
        </section>

        <button className="privacy-back" onClick={onBack}>
          Back to Home
        </button>
      </main>
      <footer className="landing-footer">
        <p>
          &copy; {new Date().getFullYear()} Santa Thadeu Health Services. All
          rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default DataDeletion;
